import { mapActions, mapState } from 'vuex';
import { KEYS } from '@/utils/constants';
export default {
    name: 'Login',
    data: () => ({
        email: '',
        show: false,
        message: '',
        colorAlert: 'red',
        password: '',
        valid: false,
        emailRules: {
            name: 'Email',
            type: 'email',
            required: true,
            valid: true
        },
        passwordRules: {
            name: 'Senha',
            type: 'password',
            required: true,
            length: 8,
            valid: true
        },
        loading: false,
        isMobile: false
    }),
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    methods: {
        ...mapActions('user', ['getUser']),
        ...mapActions('router', ['setRedirectUrl']),
        async login() {
            this.loading = true;
            if (!this.$cookies.get(KEYS.ACCEPETD_COOKIES)) {
                this.message = 'Para acessar o sistema é necessário aceitar nossa política de privacidade e cookies.';
                this.colorAlert = 'red';
                this.show = true;
                return (this.loading = false);
            }
            this.valid = !this.valid;
            await setTimeout(() => {}, 500);
            if (this.formValid) {
                const { error } = await this.getUser({
                    email: this.email,
                    password: this.password
                });
                if (error) {
                    this.message = error;
                    this.colorAlert = 'red';
                    this.show = true;
                    this.loading = false;
                } else {
                    if (this.redirectUrl.length) {
                        const url = this.redirectUrl;
                        this.setRedirectUrl('');
                        this.$router.push(url);
                    } else {
                        this.$router.push({ name: 'Home' });
                    }
                }
            } else {
                this.message = 'Preencha os campos obrigatórios';
                this.colorAlert = 'red';
                this.show = true;
                this.loading = false;
            }
        },
        goToRecoverPassword() {
            this.$router.push({ name: 'RecoverPassword' });
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('router', ['redirectUrl']),
        btnColor() {
            return this.formValid ? 'blue' : 'green';
        },
        formValid() {
            return this.emailRules.valid && this.passwordRules.valid ? true : false;
        }
    }
};
